var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegasRacesLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 25,
    viewBox: "0 0 161 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.469 8.983l1.279 1.813h1.144l-.353-1.12-2.07-.693z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.469 8.983l1.279 1.813h1.144l-.353-1.12-2.07-.693z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.363 9.302l-.47 1.494h1.525l1.706-2.417-2.76.923z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.363 9.302l-.47 1.494h1.525l1.706-2.417-2.76.923z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.044 18.278l.672.953.673-.953-.673-2.13-.672 2.13z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.044 18.278l.672.953.673-.953-.673-2.13-.672 2.13z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.716 19.23l.897 1.271h2.902l-2.348-1.755-1.45.485z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.716 19.23l.897 1.271h2.902l-2.348-1.755-1.45.485z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.844 7.181L93.5 8.636l1.113-.275-.598-1.004-2.17-.176z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.844 7.181L93.5 8.636l1.113-.275-.598-1.004-2.17-.176z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.732 6.796l-.12 1.565 1.484-.366 1.11-2.76-2.474 1.561z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.732 6.796l-.12 1.565 1.484-.366 1.11-2.76-2.474 1.561z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.595 16.802l.87.765.438-1.088-1.138-1.91-.17 2.233z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.595 16.802l.87.765.438-1.088-1.138-1.91-.17 2.233z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.465 17.567l1.16 1.02 2.822-.697-2.681-1.143-1.301.82z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.465 17.567l1.16 1.02 2.822-.697-2.681-1.143-1.301.82z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.168 19.93l.178 1.164 1.02-.535.34-2.212-1.538 1.584z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.168 19.93l.178 1.164 1.02-.535.34-2.212-1.538 1.584z",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.347 21.094l.238 1.551 2.586 1.356-1.318-2.661-1.506-.246z",
    fill: "url(#paint18_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.347 21.094l.238 1.551 2.586 1.356-1.318-2.661-1.506-.246z",
    fill: "url(#paint19_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2 19.34l.438 1.089.87-.765-.17-2.234-1.137 1.91z",
    fill: "url(#paint20_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2 19.34l.438 1.089.87-.765-.17-2.234-1.137 1.91z",
    fill: "url(#paint21_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.638 20.429l.585 1.45 2.82.698-1.884-2.271-1.52.123z",
    fill: "url(#paint22_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.638 20.429l.585 1.45 2.82.698-1.884-2.271-1.52.123z",
    fill: "url(#paint23_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.829 5.58l1.939 1.016 1.02-.534-.81-.833-2.15.35z",
    fill: "url(#paint24_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.829 5.58l1.939 1.016 1.02-.534-.81-.833-2.15.35z",
    fill: "url(#paint25_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.55 4.51l.238 1.552 1.36-.713.454-2.95-2.053 2.112z",
    fill: "url(#paint26_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.55 4.51l.238 1.552 1.36-.713.454-2.95-2.053 2.112z",
    fill: "url(#paint27_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.428 12.782l.34 2.213 1.02.534.179-1.163-1.54-1.584z",
    fill: "url(#paint28_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.428 12.782l.34 2.213 1.02.534.179-1.163-1.54-1.584z",
    fill: "url(#paint29_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.787 15.529l1.36.713 2.586-1.356-2.866-.467-1.08 1.11z",
    fill: "url(#paint30_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.787 15.529l1.36.713 2.586-1.356-2.866-.467-1.08 1.11z",
    fill: "url(#paint31_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.478 4.266l2.117.522.87-.764-.976-.616-2.01.858z",
    fill: "url(#paint32_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.478 4.266l2.117.522.87-.764-.976-.616-2.01.858z",
    fill: "url(#paint33_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.881 2.573l.584 1.45 1.16-1.019v-.001L93.397.026l-1.516 2.547z",
    fill: "url(#paint34_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.881 2.573l.584 1.45 1.16-1.019v-.001L93.397.026l-1.516 2.547z",
    fill: "url(#paint35_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.666 10.885l.834 2.07 1.112.274-.09-1.174-1.856-1.17z",
    fill: "url(#paint36_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.666 10.885l.834 2.07 1.112.274-.09-1.174-1.856-1.17z",
    fill: "url(#paint37_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.41 11.89l-.798 1.34 1.484.366 2.207-1.94-2.894.235z",
    fill: "url(#paint38_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.41 11.89l-.798 1.34 1.484.366 2.207-1.94-2.894.235z",
    fill: "url(#paint39_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.321.203l1.512 2.55 1.52.126-.352-1.528L88.32.203z",
    fill: "url(#paint40_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.321.203l1.512 2.55 1.52.126-.352-1.528L88.32.203z",
    fill: "url(#paint41_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.985 9.675l-.354 1.12h1.144l1.28-1.812-2.07.692z",
    fill: "url(#paint42_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.985 9.675l-.354 1.12h1.144l1.28-1.812-2.07.692z",
    fill: "url(#paint43_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.399 8.379l1.706 2.417h1.526l-.472-1.494-2.76-.923z",
    fill: "url(#paint44_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.399 8.379l1.706 2.417h1.526l-.472-1.494-2.76-.923z",
    fill: "url(#paint45_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.134 18.278l.673.953.672-.953-.672-2.13-.673 2.13z",
    fill: "url(#paint46_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.134 18.278l.673.953.672-.953-.672-2.13-.673 2.13z",
    fill: "url(#paint47_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.008 20.501h2.902l.897-1.27-1.451-.485-2.348 1.755z",
    fill: "url(#paint48_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.008 20.501h2.902l.897-1.27-1.451-.485-2.348 1.755z",
    fill: "url(#paint49_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.509 7.357l-.598 1.004 1.112.275 1.656-1.455-2.17.176z",
    fill: "url(#paint50_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.509 7.357l-.598 1.004 1.112.275 1.656-1.455-2.17.176z",
    fill: "url(#paint51_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.317 5.235l1.11 2.76 1.484.366-.12-1.565-2.474-1.56z",
    fill: "url(#paint52_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.317 5.235l1.11 2.76 1.484.366-.12-1.565-2.474-1.56z",
    fill: "url(#paint53_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.62 16.479l.438 1.088.87-.765-.17-2.233-1.138 1.91z",
    fill: "url(#paint54_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.62 16.479l.438 1.088.87-.765-.17-2.233-1.138 1.91z",
    fill: "url(#paint55_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.076 17.89l2.822.697 1.16-1.02-1.3-.82-2.682 1.143z",
    fill: "url(#paint56_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.076 17.89l2.822.697 1.16-1.02-1.3-.82-2.682 1.143z",
    fill: "url(#paint57_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.816 18.347l.34 2.212 1.02.535.18-1.162-1.54-1.585z",
    fill: "url(#paint58_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.816 18.347l.34 2.212 1.02.535.18-1.162-1.54-1.585z",
    fill: "url(#paint59_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.67 21.34L80.352 24l2.586-1.356.238-1.55-1.506.245z",
    fill: "url(#paint60_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.67 21.34L80.352 24l2.586-1.356.238-1.55-1.506.245z",
    fill: "url(#paint61_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.014 19.664l.87.765.439-1.088-1.138-1.91-.17 2.233z",
    fill: "url(#paint62_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.014 19.664l.87.765.439-1.088-1.138-1.91-.17 2.233z",
    fill: "url(#paint63_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.479 22.577l2.822-.698.584-1.45-1.522-.123-1.884 2.27z",
    fill: "url(#paint64_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.479 22.577l2.822-.698.584-1.45-1.522-.123-1.884 2.27z",
    fill: "url(#paint65_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.735 6.062l1.02.534 1.94-1.016-2.15-.35-.81.832z",
    fill: "url(#paint66_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.735 6.062l1.02.534 1.94-1.016-2.15-.35-.81.832z",
    fill: "url(#paint67_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.922 2.399l.454 2.95 1.359.713.239-1.55-2.052-2.113z",
    fill: "url(#paint68_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.922 2.399l.454 2.95 1.359.713.239-1.55-2.052-2.113z",
    fill: "url(#paint69_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.556 14.366l.179 1.163 1.02-.534.34-2.213-1.539 1.584z",
    fill: "url(#paint70_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.556 14.366l.179 1.163 1.02-.534.34-2.213-1.539 1.584z",
    fill: "url(#paint71_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.79 14.886l2.585 1.356 1.36-.713-1.079-1.11-2.866.467z",
    fill: "url(#paint72_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.79 14.886l2.585 1.356 1.36-.713-1.079-1.11-2.866.467z",
    fill: "url(#paint73_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.058 4.024l.87.764 2.117-.522-2.011-.858-.976.616z",
    fill: "url(#paint74_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.058 4.024l.87.764 2.117-.522-2.011-.858-.976.616z",
    fill: "url(#paint75_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.898 3.004l1.16 1.02.584-1.451L76.126.026l-.228 2.978z",
    fill: "url(#paint76_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.898 3.004l1.16 1.02.584-1.451L76.126.026l-.228 2.978z",
    fill: "url(#paint77_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 12.055l-.09 1.174 1.113-.274.833-2.07L75 12.055z",
    fill: "url(#paint78_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 12.055l-.09 1.174 1.113-.274.833-2.07L75 12.055z",
    fill: "url(#paint79_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.427 13.596l1.484-.367-.798-1.338-2.893-.235 2.207 1.94z",
    fill: "url(#paint80_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.427 13.596l1.484-.367-.798-1.338-2.893-.235 2.207 1.94z",
    fill: "url(#paint81_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.522 1.351L78.17 2.88h.001l1.52-.126 1.512-2.55-2.68 1.148z",
    fill: "url(#paint82_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.522 1.351L78.17 2.88h.001l1.52-.126 1.512-2.55-2.68 1.148z",
    fill: "url(#paint83_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M87.077 7.1c-1.498-1.528-2.461-2.466-2.461-2.466s-.964.938-2.462 2.467c-.803.804-2.569 2.789-2.569 4.774 0 1.314 1.044 2.386 2.355 2.386.856 0 1.605-.455 2.007-1.153.053-.053.107-.107.187-.107.134 0 .24.08.214.188-.08.724-.482 2.467-2.034 3.057h4.603c-1.552-.59-1.954-2.36-2.034-3.057-.027-.107.107-.188.214-.188.08 0 .134.054.188.107a2.304 2.304 0 002.006 1.153c1.312 0 2.355-1.072 2.355-2.386 0-1.958-1.793-3.97-2.569-4.774zm-1.418 3.246l.642 1.985-1.685-1.234-1.686 1.234.642-1.985-1.686-1.234h2.06l.643-1.984.642 1.984h2.06l-1.632 1.234z",
    fill: "url(#paint84_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.299 4.057c.504.048.636.413.552.998l-.363 2.42h4.621l.393-2.609c.453-2.954-.847-4.852-4.471-4.852l-6.052-.006L151.4.99c-1.047.795-1.657 2.061-1.922 3.782l-.151.974c-.362 2.326.211 4.148 2.024 6.537l1.449 1.948c.936 1.258 1.178 1.855.967 3.175l-.121.785c-.151.943-.423 1.383-.997 1.383-.604 0-.785-.44-.664-1.289l.483-3.236h-4.741l-.544 3.52c-.514 3.488 1.419 5.485 4.741 5.485h1.12c3.564 0 5.253-2.06 5.827-5.737l.181-1.194c.362-2.326-.393-4.149-2.416-6.82l-1.541-2.011c-.755-1.1-.936-1.54-.785-2.546l.08-.593-1.688-1.098 2.597.002z",
    fill: "url(#paint85_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.14 1.006c-1.364 1.012-2.033 2.738-2.368 4.884l-1.842 11.942c-.514 3.551.755 6.223 4.953 6.223h.876c3.835 0 5.134-2.86 5.557-5.752l.724-4.777h-4.801l-.695 4.62c-.151.755-.302 1.226-.906 1.226-.604 0-.815-.44-.725-1.131l1.948-12.657-1.652-1.078 2.513.002h.052l.046.003c.572.029.713.404.627 1.159l-.574 3.614h4.802l.573-3.771c.484-3.049-.694-5.5-4.771-5.5L126.705 0l1.435 1.006zm-26.323.119l-3.484 22.93 4.833-.002 1.327-8.827-1.73-1.105 2.533.003c.695 0 .846.345.695 1.194l-1.049 6.99c-.151.944-.008 1.495.143 1.747l4.84.001.03-.157c-.12-.377-.189-1.164-.038-2.076l1.147-7.542c.272-1.886-.724-2.829-1.449-3.206 1.178-.409 2.144-1.477 2.446-3.551l.483-3.08c.423-2.702-1.208-4.43-3.413-4.43l-9.071-.01 1.757 1.12zm4.179 4.357l-1.754-1.133h2.594c.604 0 .786.347.665 1.07l-.483 3.174c-.091.817-.393 1.13-.967 1.13h-.695l.64-4.241zm9.012-5.474l1.697 1.083-6.197 22.965h4.31l.646-2.72-1.64-1.053h4.156l-.198 3.772 4.685.001.442-24.048h-7.901zm3.516 8.616l-.332 7.04h-1.359l1.691-7.04zM137.58.014l1.779 1.152-3.496 22.888 9.394.002.765-5.041h-4.56l.572-3.754-1.759-1.137h5.49l.755-4.966h-3.534l.431-2.866-1.745-1.127 1.88.003.038-.001h4.38l.776-5.154H137.58z",
    fill: "url(#paint86_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.139.042l1.775 1.078-6.445 22.845h4.459l.676-2.747-1.648-.994h4.247l-.211 3.762h4.882L50.339.042h-8.2zm3.254 15.575h-1.416l1.755-7.016-.339 7.016z",
    fill: "url(#paint87_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M59.658 4.079c.529.042.655.401.57.993l-.38 2.41h4.798l.401-2.6c.465-2.938-.866-4.84-4.628-4.84h-6.276l1.479.994c-1.078.781-1.712 2.05-1.987 3.761l-.148.972c-.38 2.325.212 4.121 2.093 6.51l1.5 1.944c.972 1.246 1.226 1.838.993 3.17l-.127.781c-.148.93-.443 1.374-1.035 1.374-.634 0-.803-.444-.697-1.29l.507-3.211h-4.903l-.57 3.508c-.529 3.465 1.479 5.43 4.923 5.43h1.163c3.698 0 5.43-2.028 6.044-5.684l.19-1.183c.38-2.325-.402-4.121-2.494-6.784l-1.606-2.008c-.782-1.099-.972-1.542-.803-2.536l.084-.591-1.754-1.1 2.663-.02z",
    fill: "url(#paint88_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M32.333 5.558l-1.627-1.036h2.557c.655 0 .824.38.719 1.163l-.592 3.614h4.987l.592-3.762c.507-3.043-.718-5.495-4.966-5.495h-6.234l1.627 1.078c-1.353 1.014-2.008 2.705-2.346 4.797l-1.965 12.659c-.465 3 .803 5.41 3.656 5.41h.253c1.839 0 3.255-1.48 3.804-2.473.148.465.254 2.03.254 2.473H36.2l1.965-12.574h-5.811l-.698 4.247h1.1l-.402 2.642c-.127.846-.529 1.29-1.226 1.29-.655 0-.93-.508-.803-1.417l2.007-12.616z",
    fill: "url(#paint89_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M15.131.021l1.839 1.141-3.614 22.824h9.742l.782-5.05h-4.733l.591-3.741-1.817-1.142h5.684l.782-4.945h-3.656l.444-2.853-1.817-1.12h6.53L26.69 0H15.13v.021z",
    fill: "url(#paint90_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .021l1.839 1.141-.212 22.824h6.784L15.13.02H7.925l1.838 1.141-3.402 13.779.824-14.92",
    fill: "url(#paint91_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: -10.521,
    y1: 2.987,
    x2: -10.521,
    y2: 44.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: -4.836,
    y1: 2.275,
    x2: -4.836,
    y2: 48.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E00814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 105.029,
    y1: -5.622,
    x2: 161.044,
    y2: -5.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 105.029,
    y1: -5.622,
    x2: 161.044,
    y2: -5.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 68.424,
    y1: 21.572,
    x2: -4.079,
    y2: 21.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 68.424,
    y1: 21.572,
    x2: -4.079,
    y2: 21.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 68.424,
    y1: 21.572,
    x2: -4.079,
    y2: 21.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 68.424,
    y1: 21.572,
    x2: -4.079,
    y2: 21.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 68.424,
    y1: 21.572,
    x2: -4.079,
    y2: 21.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5CD"
  })))));
}
SvgVegasRacesLogo.displayName = 'VegasRacesLogo';
export default SvgVegasRacesLogo;